import { render } from "./ThemesMain.vue?vue&type=template&id=a4ca3f20"
import script from "./ThemesMain.vue?vue&type=script&lang=js"
export * from "./ThemesMain.vue?vue&type=script&lang=js"

import "./ThemesMain.vue?vue&type=style&index=0&id=a4ca3f20&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__